import React, { useContext } from 'react';

import { ListContext } from '../ListContext';

// Convenience function to put items into props at the bottom level of
// ListContainer. So, when frequently setting up List.jsx, you can
// get items out of props without having to import useContext as well
// as ListContext.

// Could refactor to provide a function / hook that gets items out of context
// if this approach causes any problems.

export default function (WrappedComponent) {
	const ReturnedComponent = function (props) {
		const listContext = useContext(ListContext);
		const {
			items,
			loading,
			changeQueryFilterDebounced,
			refetch,
			count,
		} = listContext;

		return (
			<WrappedComponent
				{...props}
				items={items}
				loading={loading}
				count={count}
				changeQueryFilterDebounced={changeQueryFilterDebounced}
				refetch={refetch}
			/>
		);
	};

	return ReturnedComponent;
}


